import { render } from "./ApiView.vue?vue&type=template&id=1308700f"
import script from "./ApiView.vue?vue&type=script&lang=js"
export * from "./ApiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__